import { createRouter, createWebHistory } from 'vue-router';
import axios from "axios";
import Home from '../components/HomePage';
import Login from '../components/LoginPage';
import AdminPage from '../components/AdminPage';
import AdminHome from '../components/AdminHomePage';
import AdminApis from '../components/AdminApisPage';
import AdminSites from '../components/AdminSitesPage';
import AdminCron from '../components/AdminCronPage';
import {getConfig} from "@/store";
// import config from "../../../../config-front.json";

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
    },
    {
        path: '/admin',
        name: 'Admin',
        component: AdminPage,
        children: [
            {
                path: 'home',
                name: 'AdminHome',
                component: AdminHome,
                meta: {
                    title: 'Admin | Home',
                },
            },
            {
                path: 'apis',
                name: 'AdminApis',
                component: AdminApis,
                meta: {
                    title: 'Admin | Apis',
                },
            },
            {
                path: 'sites',
                name: 'AdminSites',
                component: AdminSites,
                meta: {
                    title: 'Admin | Sites',
                },
            },
            {
                path: 'tools',
                name: 'AdminTools',
                component: '',
                children: [
                    {
                        path: 'cron',
                        name: 'AdminCron',
                        component: AdminCron
                    },
                ]
            }
        ]
    }
];

const router = createRouter({
    history: createWebHistory(), // Использование истории браузера
    routes,
});

router.afterEach((to) => {
    const defaultTitle = 'API Helper';
    document.title = to.meta.title || defaultTitle;
});

router.beforeEach(async (to, from, next) => {
    const token = localStorage.getItem("authToken");

    // Если маршрут требует авторизации
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (token) {
            try {
                const response = await axios.get(getConfig().serverURL + "/server/protected.php", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (response.data.success) {
                    // Если авторизация прошла успешно, разрешаем переход
                    next();
                } else {
                    // Если авторизация не прошла, перенаправляем на страницу входа
                    next({ name: 'Login' });
                }
            } catch (error) {
                console.error("Ошибка авторизации:", error);
                // Если ошибка в запросе, перенаправляем на страницу входа
                next({ name: 'Login' });
            }
        } else {
            // Если нет токена, перенаправляем на страницу входа
            next({ name: 'Login' });
        }
    } else {
        // Если маршрут не требует авторизации, просто продолжаем
        next();
    }
});

export default router;